export const BABEL7_VERSION = '7.12.12';
